import { getHashSalt, getHashAlgorithm } from '../config/config';
import { trimByLength } from './trim-by-length';
export const hashByConfig = (value, enableHash = false) => {
  const trimmedValue = trimByLength(value);
  const hashAlgorithm = getHashAlgorithm();
  const hashSalt = getHashSalt();
  if (hashAlgorithm && enableHash) {
    return hashAlgorithm(trimmedValue, hashSalt);
  }
  return trimmedValue;
};